export const formatScheduleRange = (from: string, to: string, type: 'utc' | 'iso'): string => {
    const start = new Date(from);
    const end = new Date(to);

    const getDate = (date: Date) => type === 'utc' ? date.getUTCDate() : date.getDate();
    const getMonth = (date: Date) => date.toLocaleString("en-US", { month: "short", timeZone: type === 'utc' ? 'UTC' : undefined });
    const getYear = (date: Date) => type === 'utc' ? date.getUTCFullYear() : date.getFullYear();

    const startDate = getDate(start);
    const endDate = getDate(end);
    const startMonth = getMonth(start);
    const endMonth = getMonth(end);
    const startYear = getYear(start);
    const endYear = getYear(end);

    if (startMonth === endMonth && startYear === endYear) {
        return `${startMonth}. ${startDate}-${endDate}, ${startYear}`;
    }

    return `${startMonth}. ${startDate}-${endMonth}. ${endDate}, ${endYear}`;
};


export const formatDateRange = (from: string, to: string): string => {
    const start = new Date(from)
    const end = new Date(to)

    const startDate = start.getDate()
    const endDate = end.getDate()

    const startMonth = start.toLocaleString('en-US', { month: 'short' })
    const endMonth = end.toLocaleString('en-US', { month: 'short' })

    const startYear = start.getFullYear()
    const endYear = end.getFullYear()

    if (startMonth === endMonth && startYear === endYear) {
        return `${startMonth}. ${startDate}-${endDate}, ${startYear}`
    }

    return `${startMonth}. ${startDate}-${endMonth}. ${endDate}, ${endYear}`
}

export const formatTimeRange = (from: string, to: string): string => {
    const start = new Date(from)
    const end = new Date(to)

    // const formatTime = (date: Date) =>
        // date.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })

    const formatTime = (date: Date) =>
        date
            .toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            })
            .replace(' ', '');

    return `${formatTime(start)} - ${formatTime(end)}`
}

export const formatDateRangeReport = (from: string, to: string): string => {
    const [startY, startM, startD] = from.split("-").map(Number)
    const [endY, endM, endD] = to.split("-").map(Number)

    const startMonth = new Date(startY, startM - 1).toLocaleString('en-US', { month: 'short' })
    const endMonth = new Date(endY, endM - 1).toLocaleString('en-US', { month: 'short' })

    // Same month and year
    if (startM === endM && startY === endY) {
        return `${startMonth} ${startD}-${endD}, ${startY}`
    }

    // Same year, different months
    if (startY === endY) {
        return `${startMonth} ${startD}-${endMonth} ${endD}, ${startY}`
    }

    // Different years
    return `${startMonth} ${startD}, ${startY}-${endMonth} ${endD}, ${endY}`
}